import React, { useEffect } from 'react';
import AdminHeader from '../../../Templates/AdminHeader';
import AppHelmet from '../../../Components/AppHelmet';
import DispatchTwoList from '../Components/DispatchTwoList';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { getRRNDetails } from '../Methods';
import Moment from 'react-moment';
import { useQuery } from '../../../Utility/Hooks/URLParams';
import HeaderTitle from '../../../Components/HeaderTitle';


export default function CompletedRRNDetails({ match }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    let query = useQuery();
    
    let { id } = useParams();
    let data = useSelector(state => state?.returns?.rrnData?.find(i => i.rrn_id === parseInt(id)));


    useEffect(() => {
        dispatch(getRRNDetails(id))
    }, []);


    data = {
        ...data,
        items: data?.items?.filter(i => i.issue_qty !== 0)
        .map(i => ({...i, qty: i.issue_qty}))
    }


    return (
        <AdminHeader goBack={'/returns'} title={
            <HeaderTitle>
                {data?.document_number}
            </HeaderTitle>
        } hideAvatar>
            <AppHelmet style={`body {
                    background-color: #f0f8fe;
                }`}/>
            {/* <Fab style={{position: 'absolute', bottom: 70, right: 20}} size="small" color="primary" aria-label="add">
                <ArrowForwardIosIcon />
            </Fab> */}
            <div style={{padding: "15px 10px 10px 10px", display: 'flex'}}>
                <div style={{display: 'flex', width: "100%", fontSize: 14}}>
                    <span style={{marginLeft: 10, marginRight: 10}}><b>{data?.items_count}</b> Items </span> | <span style={{marginLeft: 10}}><b>{data?.quantity_sum}</b> Nos</span> 
                </div>
                <div style={{width: "100%", textAlign: "right", color: "#148be7"}}>
                    <div><b>Created by</b></div>
                </div>
            </div>
            <div>
                <DispatchTwoList disabledUpdateItemCount type="vdn" hideSideBox parentId={id} data={data.items} />
            </div>
            {/* <div style={{position: "fixed", bottom: 10,right: 0,left: 0, textAlign: 'center'}}>
                <Button variant="contained" size="large" onClick={() => navigate("/dispatch/create/summary/" + id + "?trip_id=" + query.get('trip_id') + "&date=" + query.get('date'))}>CREATE VDN</Button>
            </div> */}
        </AdminHeader>
    )
}